
        var result = require("!!../../../../node_modules/css-loader/index.js!./page-header.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./ClientApp/app/components/page-header/page-header.component.css
// module id = 682
// module chunks = 0